

var _fbMessenger = require('../constants/fbMessenger');

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _index = require('../utils/index');

var _index2 = _interopRequireDefault(_index);

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

var _profilemanagement = require('xo-models/src/profilemanagement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTORETURN_TIMEOUT = 5000;


define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-beaver/dist/logger', 'components/xo-return-to-merchant/dist/util'], function ($, ng, squid, template) {

    return angular.module('xo-done.directive', ['squid', 'beaver', 'xo-error-tooltip.directive', 'xo-return-to-merchant']).directive('xoDone', function () {

        return {
            template: template,
            controller: function controller($rootScope, $scope, $populate, $logger, $promise, $CheckoutAppDataModel, $CheckoutSessionModel, $CheckoutPayeeModel, $CheckoutCartModel, $locale, $ReturnToMerchant, $DeviceInfo, $state, $window, $stateParams, $pxp, $timeout) {

                $scope.isGuestSignup = $rootScope.mode && $rootScope.mode === 'signup';
                $scope.locale = $locale;

                function addPageMessage(code) {
                    var CONTENT_KEY_MAPPING = {
                        NO_UPGRADE: 'accountUpgradeFailed'
                    };
                    if (code && CONTENT_KEY_MAPPING[code]) {
                        $scope.errorMessage = {
                            msgs: [$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
                            type: 'warning'
                        };
                    }
                }

                function isThirdPartyFlow() {
                    return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience($rootScope.token);
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {

                    return $populate($scope, {
                        merchantPreferenceModel: _profilemanagement.$MerchantPreferenceModel.instance($scope.payee.merchant.id)
                    }).then(function () {
                        // Show auto return page when feature is enabled by merchant and txn
                        $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();

                        $logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
                            return_url: $scope.checkoutAppData.urls.return_url || 'not_available',
                            autoreturn_url: $scope.merchantPreferenceModel.returnUrl() || 'not_available'
                        });

                        // Set content key based on device
                        $scope.autoReturnContentKey = $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
                        $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';
                        if ($stateParams.code) {
                            addPageMessage($stateParams.code);
                        }
                        var amount = $scope.checkoutSession.transactionDetails.amount.total;
                        var code = $scope.checkoutSession.transactionDetails.amount.currency;
                        $scope.formattedAmount = squid.formatCurrency(amount, code);
                        var itemList = $scope.checkoutSession.itemsList;

                        itemList.forEach(function (item) {
                            item.quantity = squid.formatQuantity(item.quantity);
                        });
                    });
                }).then(function () {
                    var pxpContext = _index2['default'].getMessengerPXPContext();

                    $logger.info('pxp_xo_wps_fb_messenger_plugin ', pxpContext);

                    // Skipping FB messenger experience if Venmo flow detected as this is only for PayPal users
                    // Also not loading if merchant auto return is enabled

                    if (!$scope.isAutoReturn && !isThirdPartyFlow()) {
                        $promise.all([$pxp(_fbMessenger2['default'].PXP_MESSENGER_EXPT, pxpContext, _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT), $pxp(_fbMessenger2['default'].PXP_MESSENGER_HK, pxpContext, _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_HK), $pxp(_fbMessenger2['default'].PXP_MESSENGER_JP, pxpContext, _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_JP), $pxp(_fbMessenger2['default'].PXP_MESSENGER_SG, pxpContext, _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_SG), $pxp(_fbMessenger2['default'].PXP_MESSENGER_PH, pxpContext, _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_PH)]).then(function () {
                            var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var _squid$$locale = squid.$locale;
                            _squid$$locale = _squid$$locale === undefined ? {} : _squid$$locale;
                            var country = _squid$$locale.country;
                            var _$scope$checkoutSessi = $scope.checkoutSession.payer;
                            _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
                            var payerId = _$scope$checkoutSessi.id;


                            $logger.info('Messenger_done_page_PXP_RESULT', results);

                            var _results$ = results[0];
                            _results$ = _results$ === undefined ? {} : _results$;
                            var treatment_name = _results$.treatment_name,
                                _results$2 = results[1];
                            _results$2 = _results$2 === undefined ? {} : _results$2;
                            var hk_treatment_name = _results$2.treatment_name,
                                _results$3 = results[2];
                            _results$3 = _results$3 === undefined ? {} : _results$3;
                            var jp_treatment_name = _results$3.treatment_name,
                                _results$4 = results[3];
                            _results$4 = _results$4 === undefined ? {} : _results$4;
                            var sg_treatment_name = _results$4.treatment_name,
                                _results$5 = results[4];
                            _results$5 = _results$5 === undefined ? {} : _results$5;
                            var ph_treatment_name = _results$5.treatment_name;


                            if (treatment_name === _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT || hk_treatment_name === _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_HK || jp_treatment_name === _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_JP || sg_treatment_name === _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_SG || ph_treatment_name === _fbMessenger2['default'].PXP_MESSENGER_PLUGIN_TREATMENT_PH) {
                                $logger.info('messenger_done_page_test_traffic');
                                $logger.info('checkout_fpti', {
                                    buyer_country: country,
                                    buyer_id: payerId,
                                    design: 'fbmessenger',
                                    from: 'XO_SUCCESS',
                                    eligibility_reason: 'messenger_treatment'
                                });
                                $scope.pxpMessengerIntegrationEnabled = true;
                            } else {
                                $logger.info('messenger_done_page_control_traffic');
                                $logger.info('checkout_fpti', {
                                    buyer_country: country,
                                    buyer_id: payerId,
                                    design: 'fbmessenger',
                                    from: 'XO_SUCCESS',
                                    eligibility_reason: 'messenger_control'
                                });
                                $scope.pxpMessengerIntegrationEnabled = false;
                            }
                        });
                    }

                    $('#outerWrapper').addClass('xo-done');

                    $scope.expansion = false;
                    $scope.toggle = function () {
                        if ($scope.expansion === false) {
                            $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
                            $scope.expansion = true;
                        } else {
                            $scope.expansion = false;
                        }
                        return $scope.expansion;
                    };

                    $scope.autoReturnStatementClick = function (event) {
                        event.preventDefault();
                        if (event.target && event.target.nodeName === 'A') {
                            $logger.info('autoreturn_statement_clicked');
                            $scope.returnToMerchant();
                        }
                    };

                    if ($scope.isAutoReturn) {
                        $logger.info('autoreturn_to_merchant');
                        $timeout($scope.returnToMerchant, AUTORETURN_TIMEOUT);
                    }
                });

                $scope.$on('localeChange', function () {
                    if ($stateParams.code) {
                        addPageMessage($stateParams.code);
                    }
                });

                $scope.returnToMerchant = function () {
                    $logger.info('return_to_merchant_clicked');
                    return $state.go('checkout.end');
                };

                $rootScope.$on('$stateChangeSuccess', function (event, newState, newParams, oldState) {
                    if (oldState.name === 'checkout.done') {
                        $('#outerWrapper').removeClass('xo-done');
                    }
                });
            }
        };
    });
});

_thirdPartyInfo.thirdPartyExperience;

_profilemanagement.$MerchantPreferenceModel;


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/done/directive.js
// module id = ./components/xo-page-components/src/done/directive.js
// module chunks = 1